<template>
    <ui-modal
        size="xs"
        name="personalize-message"
		icon="-"
		footer-background="#fff"
	>
		<template #title>
            <div class="title-message">
                <em class="fal fa-comment-alt-lines" />
                <span>{{ title }}</span>
            </div>
		</template>

        <template>
			<div class="text-subtitle">
				<span>Personalize a mensagem que você deseja exibir quando um usuário sem acesso tentar utilizar o recurso.</span>
			</div>

			<div class="content-personalize-message">
                <ui-input
					label="Título:"
					placeholder="Sem permissão para acessar unidades"
					v-model="form.title"
                />

				<ui-textarea
					label="Mensagem:"
					placeholder="Em caso de dúvidas, fale com seu gestor ou envie um e-mail para: contato@contato.com.br"
					v-model="form.message"
				/>
			</div>
        </template>

        <template #footer>
			<div v-if="load" class="loading-message">
				<ui-load-indicator bg-color="#e7e9f4" color="#3FACFF" :h="30" :stroke="6" />
			</div>

			<ui-button
				design="link"
				@click="close"
			>
				Cancelar
			</ui-button>

            <ui-button
				design="md success mw-100"
				:disabled="form.message.length < 10 || loading"
				@click="submit"
			>
				<span v-if="loading" class="loading-submit-teams">
					<ui-load-indicator bg-color="#fff" color="#41A870" :h="20" :stroke="6" />
				</span>
				Salvar
			</ui-button>
		</template>
    </ui-modal>
</template>

<script>
import { uiLoadIndicator, uiOverlayLoad } from '@/components/ui'
import { uiButton } from "@/components/ui/buttons"
import { uiInput, uiTextarea } from '@/components/ui/form'
import { uiModal } from "@/components/ui/modal"
import { alertMixin } from '@/mixins'
import { product } from '@/services/axios'

export default {
	name: 'ui-personalize-message-modal',

	components: {
		uiModal,
		uiButton,
		uiOverlayLoad,
		uiInput,
		uiTextarea,
		uiLoadIndicator
	},

	props: {
		title: {
			type: String,
			required: false,
			default: 'Personalizar Mensagem'
		}
	},

	mixins: [
		alertMixin
	],

	data() {
		return {
			load: false,
			form: {
				title: '',
				message: ''
			},
			id: null,
			loading: false
		}
	},

	created() {
		this.id = this.$route.params.id
		this.$root.$on('modal-open-personalize-message', async () => {
			this.load = true
			try {
				const response = await product.listProductConfiguration(this.id)
				this.form = response.data.data ? response.data.data.value : {}
			} catch(error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				}
			} finally {
				this.load = false
			}
		})
	},

	beforeDestroy() {
		this.$root.$off('modal-close-personalize-message')
	},

	methods: {
		close() {
			this.$root.$emit('modal-close-personalize-message')
		},

		async submit() {
			this.loading = true
			try {
				const response = await product.postProductConfiguration(this.id, this.form)
				this.$mx_alertSuccess(response.data.msg)
				this.loading = false
				this.close()
			} catch (error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				} else {
					this.$mx_alertError(error)
				}
				this.loading = false
			} finally {
				this.loading = false
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>